import { graphql } from "@apollo/react-hoc"
import FEATURE_FLAGS_QUERY from "./FeatureFlagsQuery.gql.js"

const withFeatureFlags = graphql(FEATURE_FLAGS_QUERY, {
  props: ({ data }) => ({
    enabledFeaturesError: data.error,
    enabledFeaturesLoading: data.loading,
    enabledFeatures: data.currentUser ? data.currentUser.enabledFeatures : [],
  }),
})

export default withFeatureFlags
